(function () {
    'use strict';

    drvTagList.$inject = [];
    drvTagListCtrl.$inject = ['$location', '$scope', 'SystemService', 'TagsService', 'DialogService', 'NavigationAidService'];

    angular
        .module('app')
        .directive('drvTagList', drvTagList);

    function drvTagList() {
        var directive = {
            templateUrl: 'app/dashboard/tag-list.tmpl.html',
            scope: {
                label: '@',
                configuration: '='
            },
            controller: drvTagListCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                configuration: '=',
                fieldTypes: '=',
                viewMode: '<?'
            }
        };
        return directive;
    }

    function drvTagListCtrl($location, $scope, SystemService, TagsService, DialogService, NavigationAidService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.tagCount = 0;
        drvCtrl.currentPage = 1;
        drvCtrl.updateList = updateList;
        drvCtrl.deleteTag = deleteTag;
        drvCtrl.deleteSelectedTags = deleteSelectedTags;
        drvCtrl.showTagUsage = showTagUsage;
        drvCtrl.close = close;
        drvCtrl.newTag = newTag;
        drvCtrl.loading = false;
        drvCtrl.error = null;
        Object.defineProperty(drvCtrl, 'selectedTags', {
            get: function () {
                return _(drvCtrl.tags)
                    .filter('Selected')
                    .value();
            }
        });

        activate();

        function activate() {
            drvCtrl.searchDelay = SystemService.getSearchDelay();

            // Watch for update on generic search text, update list if it changes
            $scope.$watch('drvCtrl.genericSearch', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    updateList();
                }
            });

            updateList();
        }

        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            drvCtrl.allTagsSelected = false;
            drvCtrl.loading = true;

            // Page size will be supplied if it exists
            var pageSize = null;
            if (!angular.isUndefined(drvCtrl.configuration.ListPageSize) && drvCtrl.configuration.ListPageSize !== null) {
                pageSize = angular.copy(drvCtrl.configuration.ListPageSize);
            }

            var getPromise = TagsService.query({
                currentPage: drvCtrl.currentPage,
                pageSize: pageSize,
                genericSearch: drvCtrl.genericSearch
            })
                .then(getTagsOk, getTagsError)
                .then(function () {
                    drvCtrl.loading = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getTagsOk(data) {
                if (getPromise === updateList.currentPromise) {
                    drvCtrl.error = null;
                    drvCtrl.tags = data.Tags;
                    drvCtrl.tagCount = data.TagCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getTagsError(response) {
                if (getPromise === updateList.currentPromise) {
                    drvCtrl.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /**
         * Delete the tag.
         */
        function deleteTag(tagId) {
            return DialogService.show({
                locals: { tagIds: [tagId] },
                controller: 'DeleteTagDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/tag/delete-tag-dialog.tmpl.html'
            }).then(deleteOk);

            function deleteOk() {
                TagsService.remove(tagId)
                    .then(deleteTagOk, deleteTagError);

                function deleteTagOk(success) {
                    drvCtrl.updateList();
                }

                function deleteTagError(response) {
                    DialogService.error('Error deleting Tag', response);
                }
            }
        }

        /**
         * Delete the selected tags.
         */
        function deleteSelectedTags() {
            if (ensureTagsSelection()) {
                var selectedTagIds = _.map(drvCtrl.selectedTags, 'Id');

                return DialogService.show({
                    locals: { tagIds: selectedTagIds },
                    controller: 'DeleteTagDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/tag/delete-tag-dialog.tmpl.html'
                }).then(deleteTagsConfirmed);
            }

            function deleteTagsConfirmed() {
                TagsService.multiDelete(selectedTagIds)
                    .then(deleteTagsOk, deleteTagsError);
            }

            function deleteTagsOk(success) {
                updateList();
            }

            function deleteTagsError(response) {
                DialogService.error('Error deleting tag' + (selectedTagIds.length > 1 ? 's' : ''), response);
            }
        }

        /**
         * Show usage for the selected tags.
         */
        function showTagUsage() {
            if (!ensureTagsSelection()) {
                return;
            }

            var selectedTagIds = _.map(drvCtrl.selectedTags, 'Id');

            TagsService.getLinkedItems(selectedTagIds)
                .then(getLinkedItemsOk, getLinkedItemsError);

            function getLinkedItemsOk(linkedItems) {
                DialogService.show({
                    locals: { linkedItems: linkedItems },
                    controller: 'TagUsageDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/tag/tag-usage-dialog.tmpl.html'
                });
            }

            function getLinkedItemsError(response) {
                DialogService.error('Error fetching Tag usage', response);
            }
        }

        /**
         * Ensure at least one tag is selected.
         * Displays a dialog 'No tags were selected' if no tags are selected.
         * @return {bool} true if at least one tag is selected, else false
         */
        function ensureTagsSelection() {
            if (drvCtrl.selectedTags.length === 0) {
                DialogService.alert('No Tags were selected');
                return false;
            } else {
                return true;
            }
        }

        /**
         * Redirects to the new tag route
         */
        function newTag() {
            $location.url('/tags/new');
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();